import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { Link, useSearchParams } from 'react-router-dom';
import { Alert, Skeleton,Table, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Space, Tabs, Drawer, Popconfirm } from "antd";
import { RightCircleOutlined, VideoCameraOutlined, HistoryOutlined, PlusSquareOutlined, PlusCircleOutlined, StepForwardOutlined, FastForwardOutlined, HolderOutlined } from '@ant-design/icons';
import { AutoReply } from "../../comps/automate/main";
import callAPI from "../../comps/fetch/main";

function InboxAutomation() {

    const [showDrawer, setShowDrawer] = useState(false)
    let default_template = {
        "dm_template_type": "text",
        "buttons": [
          {
            "title": "click to edit",
            "type": "web_url",
            "url": ""
          }
        ],
        "delay": "60",
        "reply_comments": [],
        "automate_all": "false",
        "enable": true,
        "triger_words": [
          "Link",
          "tool",
          "doc",
          "🔗"
        ],
        "welcome_message": {},
        "dms": [
          "hii"
        ],
        "enable_dm_reply": true,
        "enable_comment_reply": false,
        "dm_shared_reply": true,
        "followers_only": true
      }
    const [data, setData] = useState([])

    const [selectedData, setSelectedData] = useState()

    const [initalState, setInitalState] = useState()

    const [publishing, setPublishing] = useState(false)
    const[callPostAPi, setCallPostAPi] = useState(false)

    const [dataPostedState,setDataPostedState] = useState()

    useEffect(() => {
        if (!callPostAPi || callPostAPi == undefined || callPostAPi == false) {
            return
        }
        messageApi.open({
            type: 'loading',
            content: 'Please wait updating',
            duration: 0,
        });
        let temp_data = {...selectedData}
        let payload = { ...data.automations[temp_data.index], auto_reply : temp_data?.auto_reply }


        let apiURL = "dm_automation"
        console.log("payload======", payload)
        // localStorage.setItem("previous_config", JSON.stringify(payload))
        callAPI({ url: apiURL, method: "POST", body: payload, loadingState: setLoading, dataState: setDataPostedState })
        setCallPostAPi(false)


    }, [callPostAPi])

    useEffect(() => {
        if(dataPostedState == undefined || dataPostedState == false){
            return
        }
        
        let temp_data = [...(data?.automations || [] )]
        if(selectedData.index){
          temp_data[selectedData.index].auto_reply = selectedData.auto_reply
          temp_data = {automations : [...temp_data]}
        }else{
          temp_data = {automations : [selectedData,...temp_data]}
          // console.log("=-=-=-=-=-=" , selectedData)
        }
              
        setData(temp_data)
        setShowDrawer(false)
        messageApi.destroy()
        
    }, [dataPostedState])


    const HandlePublish = () => {
        setCallPostAPi(true)
    }

    const [posting, setPosting] = useState(false)

    const getRandomColor = () => {
        const colors = [
          'magenta', "gold","lime","cyan","blue","geekblue","purple"
        ];
        return colors[Math.floor(Math.random() * colors.length)];
      };

    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState()


    const [expandedRow, setExpandedRow] = useState(null);

    const handleExpand = (expanded, record) => {
    if (expanded) {
        setExpandedRow(record.automate_id);
    } else {
        setExpandedRow(null);
    }
    };
    
    useEffect(() => {
    
    
        if (data.automations == undefined) {
          let url = `dm_automation`
          callAPI({ url: url, method: "GET", loadingState: setLoading, dataState: setData })
        }
      }, [])

    
  const defaultColumns = [
    {
      title: 'Message Includes',
      dataIndex: 'triger_words',
      render: (_, record) => (
        record?.auto_reply?.automate_all == "true" ? <Tag color={"purple"} style={{fontSize:'14px'}}>
        All Messages
      </Tag> : <>
        
          {
          
          (record?.auto_reply?.triger_words || []).map((tag) => {
            
            return (
              <Tag style={{fontSize:'14px'}}  key={tag}>
                {tag}
              </Tag>
            );
          })}
        </>
      ),        
    },
    {
        title: 'Reply Type',
      dataIndex: 'dm_template_type',
      render: (_, record) => (
        <>
          {record?.auto_reply?.dm_template_type}
        </>
      ),     
    },
    {
        title: 'Actions',
      render: (_, record, index) => (
        <Space>
        <Popconfirm
            title="Delete this Automation?"
            description="Are you sure to delete this automation?"
            okText="Yes, Delete"
            cancelText="No, Ignore"
            placement='left'
            onConfirm={ () => {
            
            } }
        >
            <Button danger onClick={() => {
                

                // setSelectedData({ auto_reply : record?.auto_reply, index: index});
                // if (selectedData?.index != index){
                //     setSelectedData({ auto_reply : record?.auto_reply, index: index});
                // }
                
                // setShowDrawer(true)
            }}>Delete</Button>

        </Popconfirm>

          <Button onClick={() => {
            if (selectedData?.index != index){
                setSelectedData({ auto_reply : record?.auto_reply, index: index});
            }
            
            setShowDrawer(true)
          }}>Edit</Button>

          
        </Space>
        
      ),     
    }
    
  ];

    return (
        <div className="page-layout">
        {contextHolder}
  
        <Sider />
        <div className="page-content">
            <div className="heading" style={{maxWidth:'90%'}}>
                <p>Go Back</p>
                <h1>Inbox automation</h1>
                <p style={{opacity:'.4', lineHeight:'24px',fontSize:'14px'}}>Trigger instant responses to common inquiries by setting up keyword-based automations. When a message contains a specific word or phrase, a pre-set reply can be sent automatically, helping you respond quickly and efficiently to your audience's queries.</p>
            </div>
            <div style={{display:'flex', flexDirection:'row', alignContent:'center', justifyContent:'space-between', padding:"10px 20px"}}>
                <h3>My Automations</h3>
                <Button type="primary" style={{marginBottom:'20px'}} onClick={() => {
                    setSelectedData({auto_reply:default_template , index:data.length});
                    setShowDrawer(true)
                }}>New Automation</Button>
            </div>
            <div>
            <Table                
                bordered
                dataSource={data?.automations || []}
                rowKey = "automate_id"
                // expandable={{
                //     expandedRowRender: (record) => (
                      
                //         <p
                //           style={{
                //             margin: 0,
                //           }}
                //         >
                //           {record?.auto_reply?.description}
                //         </p>
                      
                //     ),
                    
                //   }}
                columns={defaultColumns}
            />
            </div>
        </div>

        <Drawer
                    title={"DM automation"}
                    placement="right"
                    open={showDrawer}
                    style={{ backgroundColor: '#f5f5ff' }}
                    width={'600px'}
                    onClose={() => { setShowDrawer(false); }}
                    extra={
                        <Space>
                            <Button onClick={() => { setShowDrawer(false); }}>Cancel</Button>
                            <Button type="primary"
                                onClick={() => HandlePublish()} loading={posting}>
                                Publish
                            </Button>
                        </Space>
                    }
                >
                    <AutoReply state={selectedData} setData={setSelectedData} isStory={false} isNextPostReply={false} isDMAuto={true} AutomateAll={false}/>
                    {/* <AutoReply /> */}
                </Drawer>

        </div>
    )


}

export default InboxAutomation

